import classNames from 'classnames';
import { dsClass } from '../../../common/constants/dsClasses.js';
import { paths } from '../../../common/constants/pathVariables.js';
import { t } from '../../../common/i18n/index.js';
import { FORM_GRID_FULL_WIDTH } from '../../../common/react-hook-form/FormGridFieldset/FormGridFieldset.js';

export const PrivacyStatement = () => (
  <p className={classNames(FORM_GRID_FULL_WIDTH, dsClass.TEXT_XS, dsClass.MARGIN_VERTICAL_4)}>
    {t.GZUM('For more information on communication and marketing, see ')}
    <a href={paths.ELISA_PRIVACY_POLICY} rel="noreferrer" target="_blank">
      {t.GZUN('Elisa’s privacy policy')}
    </a>
    {t.GZUO('. You can change your choices or prohibit marketing in OmaElisa or by contacting our customer service.')}
  </p>
);
